import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Twitter = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1368 2.06531L8.67138 6.12304L5.90358 2.06531H2.06138L6.53541 8.62436L2 13.9347H3.56293L7.22933 9.64163L10.1578 13.9347H14L9.36541 7.14046L13.6996 2.06531H12.1368ZM10.8518 12.7821L7.96747 8.6262V8.62596L4.23763 3.25172H5.20113L11.8153 12.7821H10.8518Z"
        fill="#15171A"
      />
    </svg>
  )
})

export default Twitter
